import { connect } from "react-redux";

import { setShowCompressorStateAction } from "../model/Diagramme";
import GrafikenInfoPanel from "./GrafikenInfoPanel";

export default connect(state => ({
	show_compressor_state: state.charts.show_compressor_state
}), (dispatch, own_props) => ({
	setShowCompressorState: value => {
		dispatch(setShowCompressorStateAction(value));
	}
}))(GrafikenInfoPanel);
